import Vue from "vue";
import Router from "vue-router";
import home from "@/views/home";
import Redirect from "@/views/sso";
Vue.use(Router);

const router = new Router({
  routes: [
    // {
    //   path: "/report",
    //   name: "风控报告",
    //   component: () => import("@/views/report"),
    // },
    {
      path: "/report",
      name: "风控报告",
      redirect: "/report/previous",
    },
    {
      path: "/report2",
      name: "风控报告2",
      redirect: "/report/previous",
    },
    {
      path: "/report/previous",
      name: "风控报告_开始",
      component: () => import("@/views/reportPrevious.vue"),
    },
    {
      path: "/report/preview",
      name: "风控报告_预览",
      component: () => import("@/views/reportPreview.vue"),
    },
    {
      path: "/report/:type",
      name: "风控报告_编辑",
      component: () => import("@/views/report2"),
    },
    {
      path: "/",
      component: Redirect,
      //   redirect: "/PC/home",
    },
    {
      path: "",
      name: "home",
      component: home,
      children: [
        {
          path: "/page1",
          name: "page1",
          component: () => import("@/views/page1"),
        },
        {
          path: "/page2",
          name: "page2",
          component: () => import("@/views/page2"),
        },
        {
          path: "/page3",
          name: "page3",
          component: () => import("@/views/page3"),
        },
        {
          path: "/PC/home_domesitc",
          name: "page4",
          component: () => import("@/views/page4"),
        },
        {
          path: "/PC/gmry",
          name: "gmry",
          component: () => import("@/views/gmry"),
        },
        {
          path: "/PC/home_domesitc/:part",
          name: "page5",
          component: () => import("@/views/page5"),
        },
        {
          path: "/page6",
          name: "page6",
          component: () => import("@/views/page6"),
        },
        {
          path: "/PC/home_overseas",
          name: "page7",
          component: () => import("@/views/home_overseas_light"),
        },
        {
          path: "/PC/home_overseas_light",
          name: "home_overseas_light",
          component: () => import("@/views/home_overseas_light"),
        },
        {
          path: "/PC/demo/contractManage",
          name: "demo_contractManage",
          component: () => import("@/views/demo_contractManage"),
        },
        {
          path: "/PC/contractManage",
          name: "new_contractManage",
          component: () => import("@/views/demo_contractManage_new"),
        },
        {
          path: "/PC/contractManageList",
          name: "new_contractManageList",
          component: () => import("@/views/demo_contractManage_newList"),
        },
        {
          path: "/PC/page/:companyname/:riskname",
          name: "/PC/page/companyname/riskname",
          component: () => import("@/views/page8"),
        },
        {
          path: "/PC/page/Ebitda/:company_name",
          name: "Ebitda",
          component: () => import("@/views/page8"),
        },
        {
          path: "/page8",
          name: "page8",
          component: () => import("@/views/page8"),
        },
        {
          path: "/page9",
          name: "page9",
          component: () => import("@/views/page9"),
        },
        {
          path: "/PC/home",
          name: "page10",
          component: () => import("@/views/newHome3"),
        },
        {
          path: "/PC/home2",
          name: "newHome2",
          component: () => import("@/views/newHome2"),
        },
        {
          path: "/PC/home3",
          name: "newHome3",
          component: () => import("@/views/newHome3"),
        },
        {
          path: "/PC/newhome",
          name: "newhome",
          component: () => import("@/views/newHome"),
        },
        {
          path: "/subCompany",
          name: "公司",
          component: () => import("@/views/page11"),
        },
        {
          path: "/integrity",
          name: "廉洁首页",
          component: () => import("@/views/lianjieIndex"),
        },
        {
          path: "/PC/integrity_overseas",
          name: "廉洁_集团境外风险概览",
          component: () => import("@/views/integrity_overseas"),
        },
        {
          path: "/department",
          name: "部门",
          component: () => import("@/views/page12"),
        },
        {
          path: "/disfinancingtrade",
          name: "融资性贸易判别",
          component: () => import("@/views/disfinancingtrade"),
        },
        {
          path: "/disfinancingtradeNew",
          name: "新融资性贸易判别",
          component: () => import("@/views/disfinancingtrade_new"),
        },
        {
          path: "/kriDetail",
          name: "kri详情页",
          component: () => import("@/views/kriDetail"),
        },
        {
          path: "/entry",
          name: "数据查询下载平台",
          component: () => import("@/views/entry"),
        },
        {
          path: "/pdf",
          name: "pdf",
          component: () => import("@/views/pdf"),
        },
      ],
    },
  ],
});
export default router;
